import { p2 } from '@/lib/dom';

/** Realtime clock — toolbar (HH:MM:SS) + kiosk overlay (full datetime, to compare with camera-burned time). */
export function startClock(): void {
  const tick = (): void => {
    const d = new Date();
    const t = `${p2(d.getHours())}:${p2(d.getMinutes())}:${p2(d.getSeconds())}`;
    const c = document.getElementById('clock');
    if (c) c.textContent = t;
    const kc = document.getElementById('kioskClock');
    if (kc) kc.textContent = `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())} ${t}`;
  };
  tick();
  window.setInterval(tick, 1000);
}
